import React, { useEffect, useState } from 'react';
import * as actionCreators from '../../actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { validateDate, getAge, validateEmail, verifyInvoice } from './../../utilities';
import { Modal, Button, Alert } from 'react-bootstrap';
import './styles.css';


export function Cotizar({ cities, disabled, firstStep, icon, saveMenu, company, codpmpol, user, setLoading, titularData, saveError, handleChange, handleShowState, show, className='ct-cotizar' }) {
    const { errorDescription, alertData, details } = saveError;
    let textDetails = ""
    const [error, setError] = useState(false);
    const [mensaje, setMensaje] = useState(null);
    // const [show, setShow] = useState(false);
    const navigate = useNavigate();

    details?.forEach(e => textDetails += ' ' + e);

    const handleClose = () => {
        //setShow(false);
        handleShowState(false);
        if (alertData || (firstStep.codsec === 32 && errorDescription.length > 0)) return navigate('/');
        if ((/*firstStep.codsec === 8 ||*/ firstStep.codsec === 32 || firstStep.codsec === 161 || firstStep.codsec === 159) && !alertData)
            navigate('/qs/firstStep');
    };

    // const handleShow = () => setShow(true);

    const verifyForm = () => {
        setMensaje(null);
        if (firstStep.codsec === 27) {
            if (titularData.name.length < 2) {
                setMensaje('Revise el nombre');
                return false;
            };
            if (titularData.lastname.length < 2) {
                setMensaje('Revise el apellido');
                return false;
            };
            if (titularData.postalcode.length < 2 || titularData.postalcode.length > 4 ) {
                setMensaje('Revise el código postal');
                return false;
            };
        }
        if ((firstStep.dni[0] === '0' || Number(firstStep.dni) < 1000000 || Number(firstStep.dni) > 99999999) && Number(firstStep.dni) !== 615340) {
            setMensaje('Revise su DNI');
            return false;
        }
        if (!firstStep.email || !validateEmail(firstStep.email)) {
            if (firstStep.codsec !== 27) {
                setMensaje('Revise su E-mail');
                return false;
            }
        }
        if (firstStep.birthday) {
            if (!validateDate(firstStep.birthday)) {
                setMensaje('Revise su fecha de nacimiento');
                return false;
            } else {
                if (getAge(firstStep.birthday) < 18) {
                    setMensaje('Debe ser mayor de edad');
                    return false;
                }
                if ((firstStep.codsec === 12 || firstStep.codsec === 22) && getAge(firstStep.birthday) > 70) {
                    setMensaje('La edad máxima permitida para este producto es de 70 años inclusive');
                    return false;
                }
                if ((firstStep.codsec === 14 && getAge(firstStep.birthday) > 74)) {
                    setMensaje('La edad máxima permitida para este producto es de 74 años inclusive');
                    return false;
                }
            }
        } else {
            setMensaje('Ingrese su fecha de nacimiento');
            return false;
        }
        if (!firstStep.province) {
            setMensaje('Revise la provincia');
            return false;
        }
        if (!firstStep.city) {
            setMensaje('Revise la ciudad');
            return false;
        }
        if (firstStep.type === 'moto') {
            if (!firstStep.brand) {
                setMensaje('Revise la marca');
                return false;
            }
            if (!firstStep.year || firstStep.year > 3000 || firstStep.year < 1900) {
                setMensaje('Revise el año');
                return false;
            }
            if (!firstStep.model) {
                setMensaje('Revise el modelo');
                return false;
            }
            if (!titularData.genre) {
                setMensaje('Revise el sexo');
                return false;
            }
            if (!firstStep.payMethod && company !== 2 && company !== 52) {
                setMensaje('Revise el método de pago');
                return false;
            }
            if (!firstStep.facpol && (company === 2 || company === 52)) {
                setMensaje('Revise el número de factura');
                return false;
            }
            if (!verifyInvoice(firstStep.facpol) && (company === 2 || company === 52)) {
                setMensaje('N° de Factura solo permite números y guiones');
                return false;
            }
        }
        return true;
    }

    const handleSubmit = () => {
        if (verifyForm()) {
            setLoading();
            setError(false);
            saveMenu({
                ...firstStep,
                ...titularData,
                city: firstStep.city !== "" ? firstStep.city : titularData.city,
                vendor: user.vendor,
                codusu: user.id,
                nro: user.nro,
                token: user.token,
                sumAssured: firstStep.sumAssured?.replaceAll('.', '').replace("$ ", ""),
                grupo: user.grupo || '',
                province: firstStep.province,
                cityDescripcion: cities?.find(e=>e.value === firstStep.city )?.label || '',
            }, company, codpmpol);
            if (firstStep.codsec === 8) {
                handleChange({ step: "homeData", target: { name: 'province', value: firstStep.province } })
                handleChange({ step: "homeData", target: { name: 'city', value: firstStep.city } })
                handleChange({ step: "homeData", target: { name: 'address', value: titularData.address } })
            }
        } else {
            setError(true);
        }
    }

    useEffect(() => {
        if (codpmpol !== '') {
            if (errorDescription === "") navigate('/qs/firstStep');
            else errorDescription !== "WaitingCities" && handleShowState(true);
        }
    }, [codpmpol, navigate, errorDescription]);

    useEffect(() => {
        setError(false);
        setMensaje(null);
    }, [firstStep])

    useEffect(() => {
        if (codpmpol === '') {
            //setShow(false);
            handleShowState(false)
        }
    }, []);


    return (
        <>
            <span className={`error ${error || 'no-show'}`}><p className='m-0 text-center w-100'>{mensaje}</p></span>
            <div className={className} onClick={!disabled && handleSubmit} data-testid="test">
                {/* <FontAwesomeIcon icon={icon} /> */}
                <span>Cotizar</span>
            </div>  
            <Modal show={show} onHide={handleClose}>
                <Modal.Header>
                    <Modal.Title>¡Aviso!</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{saveError.errorDescription} {details && details.length > 0 ? details.join(", ") : ''}</p>
                </Modal.Body>

                <Modal.Footer>
                    <Button onClick={handleClose} className="main-btn">
                        Continuar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

function mapStateToProps(state) {
    return {
        firstStep: state.mainReducer.firstStep,
        titularData: state.mainReducer.titularData,
        saveError: state.mainReducer.saveError,
        company: state.mainReducer.company,
        codpmpol: state.mainReducer.codpmpol,
        user: state.mainReducer.user,
        show: state.mainReducer.show,
        cities: state.mainReducer.cities,
    }
};

const mapDispatchToProps = function (dispatch) {
    return bindActionCreators(actionCreators, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Cotizar);
